let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '订单编号',
        props: 'activityOrderNo',
        minWidth: 220,
        fixed:'left'
    },
    {
        label: '用户姓名',
        props: 'name',
        minWidth: 120,
        fixed:'left'
    },
    {
        label: '用户手机号',
        props: 'mobile',
        minWidth: 200,
        fixed:'left',
         formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.mobile) {
                return row.mobile.replace(row.mobile.substring(2,9), "*******");
            }
            else {
                return ''
            }
        }
    },
    {
        label: '订单状态',
        props: 'orderStatusName',
        fixed:'left',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.orderStatusName == '使用中') {
                return '<span style="color:#0BBAB4;">使用中</span>';
            }
            if (row.orderStatusName == '已报名') {
                return '<span style="color:#49AFE7;">已报名</span>';
            }
            if (row.orderStatusName == '已支付') {
                return '<span style="color:#2871FF;">已支付</span>';
            }
            if (row.orderStatusName == '已退款') {
                return '<span style="color:#FF2828;">已退款</span>';
            }
            if (row.orderStatusName == '已到期') {
                return '<span style="color:#8D8D8D;">已到期</span>';
            }
            if (row.orderStatusName == '换桩中') {
                return '<span style="color:#E6A23C;">换桩中</span>';
            }

        }
    },
    {
        label: '购买名称',
        props: '',
        minWidth: 180,
    },
    {
        label: '省',
        props: 'province',
        minWidth: 150,
    },
    {
        label: '市',
        props: 'city',
        minWidth: 150,
    },
    {
        label: '区',
        props: 'area',
        minWidth: 150,
    },
    {
        label: '详细地址',
        props: 'address',
        minWidth: 130,
        tooltip:true,
        formatter: function formatter(row, column, cellValue, index) {
            if (!row.address) return "";
            if (row.address.length > 10) {
              return row.address.slice(0, 10) + "...";
            }
            return row.address
        }

    },
    {
        label: '购买名称',
        props: '',
        minWidth: 180,
    },
    {
        label: '充电桩激活状态',
        props: 'activateStatusName',
        minWidth: 150,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.orderStatus == '03') {
                return '--';
            }
            else {
                return row.activateStatusName
            }
        }
    },
    {
        label: '充电桩编码',
        props: 'pileCode',
        minWidth: 180,
    },
    {
        label: '关联支付流水号',
        props: 'payTransactionNo',
        minWidth: 240,
    },
    {
        label: '退款流水号',
        props: 'refundTransactionNo',
        minWidth: 240,
        tooltip:true,
        formatter: function formatter(row, column, cellValue, index) {
            if (!row.refundTransactionNo) return "";
            if (row.refundTransactionNo.length > 30) {
              return row.refundTransactionNo.slice(0, 30) + "...";
            }
            return row.refundTransactionNo
        }
    },
    {
        label: '续约次数',
        props: 'renewalCount',
        minWidth: 90,
    },
    {
        label: '充电桩绑定时间',
        props: 'bindTime',
        minWidth: 130,
    },
    {
        label: '充电桩启用时间',
        props: 'periodStartTime',
        minWidth: 130,
    },
    {
        label: '充电桩到期时间',
        props: 'periodEndTime',
        minWidth: 130,
    },
    {
        label: '订单创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '订单备注',
        props: 'remark',
        minWidth: 200,
        tooltip:true,
        formatter: function formatter(row, column, cellValue, index) {
            if (!row.remark) return "";
            if (row.remark.length > 30) {
              return row.remark.slice(0, 30) + "...";
            }
            return row.remark
        }
    },
    {
        label: '激活切换操作人',
        props: 'activateOperatePer',
        minWidth: 200,
    },
    {
        label: '激活切换操作时间',
        props: 'activateOperateWhen',
        minWidth: 200,
    },
    {
        label: '退款操作人',
        props: 'refundOperatePer',
        minWidth: 200,
    },
    {
        label: '退款操作时间',
        props: 'refundOperateWhen',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '营销活动'
    },
    {
        type: 'title',
        name: '老499活动订单列表'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '营销活动',
    },
    {
        type: 'router',
        name: '老499活动订单列表',
        router: 'old499ActivityOrderList'
    },
    {
        type: 'title',
        name: '活动订单编辑'
    }
];


pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
};



export default pageConfig;
